import { render, staticRenderFns } from "./addmsBangDing.vue?vue&type=template&id=2165c95e&scoped=true"
import script from "./addmsBangDing.vue?vue&type=script&lang=js"
export * from "./addmsBangDing.vue?vue&type=script&lang=js"
import style0 from "./addmsBangDing.vue?vue&type=style&index=0&id=2165c95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165c95e",
  null
  
)

export default component.exports